module.exports = __webpack_public_path__ + "img/error.7063fe46.png";